<template>
    <section class="index-page">
        <h1 id="index" class="print-title">Alphabetical Index</h1>
    </section>
    <div class="break-after"></div>

    <section class="index-page-details">
        <div id="book-index"></div>
    </section>
</template>

<script>
import {registerHandlers} from "pagedjs";
import CustomHandler from "../util/CustomHandlers";

export default {
    name: "IndexPage",
    data() {
        return {
            alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
        };
    },
    mounted() {
        registerHandlers(CustomHandler);
    },
};

</script>

<style lang="scss">
.index-page {
    margin-top: 50% !important;
}
.index-page-details {
    #book-index {
        column-count: 2;
        column-gap: 20mm;
        break-inside: avoid;
    }
    #book-index.single-column {
        width: 50%;
        margin: 0 auto;
        column-count: 1;
    }

    #book-index.two-columns {
        width: 100%;
        column-count: 2;
        column-gap: 20mm;
    }
}
</style>
